function getVariation(placement) {
  return placement.split('-')[1];
}

export { getVariation as g };
//# sourceMappingURL=getVariation-zHVjyqoi.js.map
